// extracted by mini-css-extract-plugin
export default {"video":"src-modules-page-blocks-RichtextAndVideo-style__video_BEkxq"};